export enum WALLET_PROVIDERS {
  METAMASK = 'MetaMask',
  COINBASE = 'Coinbase',
  EXODUS = 'Exodus',
  TRUST_WALLET = 'TrustWallet',
  MATH_WALLET = 'MathWallet',
  BITKEEP = 'BitKeep',
}
